const foodHabit = [
  { label: "Halal foods always", value: "Halal foods always" },
  { label: "Halal foods when I can", value: "Halal foods when I can" },
  { label: "No special restrictions", value: "No special restrictions" },
  { label: "Diet conscious", value: "Diet conscious" },
];
export default foodHabit;
